/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiSearchResultItemsGetCollection200,
  ApiSearchResultItemsGetCollectionParams,
  SearchResultItemJsonld
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type api_search_result_items_get_collectionResponse200 = {
  data: ApiSearchResultItemsGetCollection200
  status: 200
}

export type api_search_result_items_get_collectionResponseSuccess = (api_search_result_items_get_collectionResponse200) & {
  headers: Headers;
};
;

export type api_search_result_items_get_collectionResponse = (api_search_result_items_get_collectionResponseSuccess)

export const getApiSearchResultItemsGetCollectionUrl = (params?: ApiSearchResultItemsGetCollectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["cateringId[]","dietId[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/search_result_items?${stringifiedParams}` : `/api/search_result_items`
}

/**
 * Retrieves the collection of SearchResultItem resources.
 * @summary Retrieves the collection of SearchResultItem resources.
 */
export const api_search_result_items_get_collection = async (params?: ApiSearchResultItemsGetCollectionParams, options?: RequestInit): Promise<api_search_result_items_get_collectionResponse> => {

  return apiCatalog<api_search_result_items_get_collectionResponse>(getApiSearchResultItemsGetCollectionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiSearchResultItemsGetCollectionQueryKey = (params?: ApiSearchResultItemsGetCollectionParams,) => {
    return [
    `/api/search_result_items`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiSearchResultItemsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError = unknown>(params?: ApiSearchResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiSearchResultItemsGetCollectionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof api_search_result_items_get_collection>>> = ({ signal }) => api_search_result_items_get_collection(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSearchResultItemsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof api_search_result_items_get_collection>>>
export type ApiSearchResultItemsGetCollectionQueryError = unknown


export function useApiSearchResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError = unknown>(
 params: undefined |  ApiSearchResultItemsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_search_result_items_get_collection>>,
          TError,
          Awaited<ReturnType<typeof api_search_result_items_get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSearchResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError = unknown>(
 params?: ApiSearchResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_search_result_items_get_collection>>,
          TError,
          Awaited<ReturnType<typeof api_search_result_items_get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSearchResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError = unknown>(
 params?: ApiSearchResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of SearchResultItem resources.
 */

export function useApiSearchResultItemsGetCollection<TData = Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError = unknown>(
 params?: ApiSearchResultItemsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiSearchResultItemsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type api_search_result_items_id_getResponse200 = {
  data: SearchResultItemJsonld
  status: 200
}

export type api_search_result_items_id_getResponse404 = {
  data: void
  status: 404
}

export type api_search_result_items_id_getResponseSuccess = (api_search_result_items_id_getResponse200) & {
  headers: Headers;
};
export type api_search_result_items_id_getResponseError = (api_search_result_items_id_getResponse404) & {
  headers: Headers;
};

export type api_search_result_items_id_getResponse = (api_search_result_items_id_getResponseSuccess | api_search_result_items_id_getResponseError)

export const getApiSearchResultItemsIdGetUrl = (id: string,) => {




  return `/api/search_result_items/${id}`
}

/**
 * Retrieves a SearchResultItem resource.
 * @summary Retrieves a SearchResultItem resource.
 */
export const api_search_result_items_id_get = async (id: string, options?: RequestInit): Promise<api_search_result_items_id_getResponse> => {

  return apiCatalog<api_search_result_items_id_getResponse>(getApiSearchResultItemsIdGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getApiSearchResultItemsIdGetQueryKey = (id: string,) => {
    return [
    `/api/search_result_items/${id}`
    ] as const;
    }


export const getApiSearchResultItemsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiSearchResultItemsIdGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof api_search_result_items_id_get>>> = ({ signal }) => api_search_result_items_id_get(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSearchResultItemsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof api_search_result_items_id_get>>>
export type ApiSearchResultItemsIdGetQueryError = void


export function useApiSearchResultItemsIdGet<TData = Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_search_result_items_id_get>>,
          TError,
          Awaited<ReturnType<typeof api_search_result_items_id_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSearchResultItemsIdGet<TData = Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof api_search_result_items_id_get>>,
          TError,
          Awaited<ReturnType<typeof api_search_result_items_id_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSearchResultItemsIdGet<TData = Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a SearchResultItem resource.
 */

export function useApiSearchResultItemsIdGet<TData = Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof api_search_result_items_id_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiSearchResultItemsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type api_search_result_items_id_deleteResponse204 = {
  data: void
  status: 204
}

export type api_search_result_items_id_deleteResponse404 = {
  data: void
  status: 404
}

export type api_search_result_items_id_deleteResponseSuccess = (api_search_result_items_id_deleteResponse204) & {
  headers: Headers;
};
export type api_search_result_items_id_deleteResponseError = (api_search_result_items_id_deleteResponse404) & {
  headers: Headers;
};

export type api_search_result_items_id_deleteResponse = (api_search_result_items_id_deleteResponseSuccess | api_search_result_items_id_deleteResponseError)

export const getApiSearchResultItemsIdDeleteUrl = (id: string,) => {




  return `/api/search_result_items/${id}`
}

/**
 * Removes the SearchResultItem resource.
 * @summary Removes the SearchResultItem resource.
 */
export const api_search_result_items_id_delete = async (id: string, options?: RequestInit): Promise<api_search_result_items_id_deleteResponse> => {

  return apiCatalog<api_search_result_items_id_deleteResponse>(getApiSearchResultItemsIdDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getApiSearchResultItemsIdDeleteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_search_result_items_id_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof api_search_result_items_id_delete>>, TError,{id: string}, TContext> => {

const mutationKey = ['apiSearchResultItemsIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof api_search_result_items_id_delete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  api_search_result_items_id_delete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiSearchResultItemsIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof api_search_result_items_id_delete>>>

    export type ApiSearchResultItemsIdDeleteMutationError = void

    /**
 * @summary Removes the SearchResultItem resource.
 */
export const useApiSearchResultItemsIdDelete = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof api_search_result_items_id_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof api_search_result_items_id_delete>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApiSearchResultItemsIdDeleteMutationOptions(options), queryClient);
    }
